import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a7034b80 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _e2855a90 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _950e864a = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _034af43a = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _1db7c283 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _fb4fe6da = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _76a5a3de = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _df4432a8 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _49875d35 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _4ca11f54 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _f858f6ac = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _0a5511b4 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _bbf92ea8 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _6d772603 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _32b7fb8a = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _48bf5c66 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _6d4921cd = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _77ab12c3 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _079ded90 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _05174ed0 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _07b3d326 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _35b1d6cf = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _1d44ff7a = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _5dee904a = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _572d22e0 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _0da3b695 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _2893e517 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _bc6d476a = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _5d5797e9 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _62f2381f = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _07e9a354 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _987b3a12 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _7c10b972 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _2ee485ac = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _9e2ff128 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _61ce84f8 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _1c501b93 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _cb13a3ea = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _05b08053 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _0cf5333d = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _3e4635bd = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _f558beee = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _a2a739d4 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _aeba6e52 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _167fb81a = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0857d3b4 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _a000a460 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _5cc050ea = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _7b02c472 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _0c1c2ec2 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _af18f26e = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _1a9537de = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _47bd612e = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _746053c0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3aecdd53 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _0cd25490 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _71138e2a = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _3ab67594 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _7a77bc51 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _a5e46c88 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _8e355cc0 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _5407f573 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _0302705a = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _3bdd0212 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _6645e6bb = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _1c5deca8 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _3a363a03 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _6b7cf242 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _564a89ab = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _d375ae46 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _5622acdc = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _5809d5c8 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _0e759270 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _4ac2bfde = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _5f20154c = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _c0f9e9e4 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _a7034b80,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _e2855a90,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _950e864a,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _034af43a,
    name: "calendar"
  }, {
    path: "/customer",
    component: _1db7c283,
    name: "customer"
  }, {
    path: "/details",
    component: _fb4fe6da,
    name: "details"
  }, {
    path: "/goals",
    component: _76a5a3de,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _df4432a8,
    name: "maisoku"
  }, {
    path: "/media",
    component: _49875d35,
    name: "media"
  }, {
    path: "/privacy",
    component: _4ca11f54,
    name: "privacy"
  }, {
    path: "/project",
    component: _f858f6ac,
    name: "project"
  }, {
    path: "/response",
    component: _0a5511b4,
    name: "response"
  }, {
    path: "/sale",
    component: _bbf92ea8,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _6d772603,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _32b7fb8a,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _48bf5c66,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _6d4921cd,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _77ab12c3,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _079ded90,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _05174ed0,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _07b3d326,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _35b1d6cf,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _1d44ff7a,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _5dee904a,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _572d22e0,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _0da3b695,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _2893e517,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _bc6d476a,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _5d5797e9,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _62f2381f,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _07e9a354,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _987b3a12,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _7c10b972,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _2ee485ac,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _9e2ff128,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _61ce84f8,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _1c501b93,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _cb13a3ea,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _05b08053,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _0cf5333d,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _3e4635bd,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _f558beee,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _a2a739d4,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _aeba6e52,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _167fb81a,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0857d3b4,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _a000a460,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _5cc050ea,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _7b02c472,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _0c1c2ec2,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _af18f26e,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _1a9537de,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _47bd612e,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _746053c0,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _3aecdd53,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _0cd25490,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _71138e2a,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _3ab67594,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _7a77bc51,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _a5e46c88,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _8e355cc0,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _5407f573,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _0302705a,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _3bdd0212,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _6645e6bb,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _1c5deca8,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _3a363a03,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _6b7cf242,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _564a89ab,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _d375ae46,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _5622acdc,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _5809d5c8,
    name: "property-property",
    children: [{
      path: "contact",
      component: _0e759270,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _4ac2bfde,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _5f20154c,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _c0f9e9e4,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
